<h2 mat-dialog-title>Rosetta Error</h2>

<mat-dialog-content class="mat-typography">
  <p>{{error.message}}</p>

  @if (error.error?.issue?.length > 0) {
    <table>
      <thead>
        <tr>
          <th>Code</th>
          <th>Severity</th>
          <th>Diagnostics</th>
        </tr>
        </thead>
        <tbody>
          @for (issue of error.error.issue; track issue) {
            <tr>
              <td><code>{{issue.code}}</code></td>
              <td><code>{{issue.severity}}</code></td>
              <td>{{issue.diagnostics}}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
